/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIdMedical = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 2h6v4h7v16H2V6h7zm0 6H4v12h16V8h-5v2H9zm4 0V4h-2v4zm-5 6v-2h2v2h2v2h-2v2H8v-2H6v-2zm10 0h-4v-2h4zm0 4h-4v-2h4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIdMedical as IdMedical };
